<div class="edit-kyc-status-dialog">
  <mat-dialog-content>
    <h3 class="header">Edit Kyc Status</h3>
    <mat-form-field>
      <mat-label>Edit Kyc Status</mat-label>
      <mat-select [formControl]="formControl">
        <mat-option [value]="'WAITING'">Not Started</mat-option>
        <mat-option [value]="'SMS_SENT'">SMS Sent</mat-option>
        <mat-option [value]="'RECEIVED_COMPLETE'">Verified</mat-option>
        <mat-option [value]="'RECEIVED_INCOMPLETE'">Verification Incomplete</mat-option>
        <mat-option [value]="'RECEIVED_FAILED'">KYC Failed</mat-option>
        <mat-option [value]="'RECEIVED_ERROR'">System Error</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Note</mat-label>
      <textarea matInput 
                [formControl]="formGroup.controls.note"
                placeholder="Add a note explaining this status change (required)"
                rows="4"></textarea>
      @if (formGroup.controls.note.hasError('required')) {
      <mat-error>
        Note is required
      </mat-error>
      }
    </mat-form-field>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-stroked-button (click)="onCancel($event)">Cancel</button>
      <button mat-flat-button [disabled]="!formGroup.valid" (click)="onSubmit($event)">Submit</button>
    </div>
  </mat-dialog-content>
</div>
